export const clearAll = () => {
	localStorage.clear()
}

export const setAuthorityToken = (val) => {
	localStorage.setItem('QsAuthToken', JSON.stringify(val))
}
export const getAuthorityToken = () => {
	return localStorage.getItem("QsAuthToken") ? JSON.parse(localStorage.getItem("QsAuthToken")) : null
}
export const removeAuthorityToken = () => {
	return localStorage.removeItem("QsAuthToken")
}

export const setUserInfo = (val) => {
	localStorage.setItem('UserInfo', JSON.stringify(val))
}
export const getUserInfo = () => {
	return localStorage.getItem('UserInfo') ? JSON.parse(localStorage.getItem("UserInfo")) : null
}
export const removeUserInfo = () => {
	return localStorage.removeItem("UserInfo")
}

export const setPermissions = (val) => {
	localStorage.setItem('Permissions', JSON.stringify(val))
}
export const getPermissions = () => {
	return localStorage.getItem('Permissions') ? JSON.parse(localStorage.getItem("Permissions")) : null
}
export const removePermissions = () => {
	return localStorage.removeItem("Permissions")
}

export const setRoles = (val) => {
	localStorage.setItem('Roles', JSON.stringify(val))
}
export const getRoles = () => {
	return localStorage.getItem('Roles') ? JSON.parse(localStorage.getItem("Roles")) : null
}
export const removeRoles = () => {
	return localStorage.removeItem("Roles")
}



export const setOriginRouters = (val) => {
	localStorage.setItem('OriginRouters', JSON.stringify(val))
}
export const getOriginRouters = () => {
	return localStorage.getItem('OriginRouters') ? JSON.parse(localStorage.getItem("OriginRouters")) : null
}
export const removeOriginRouters = () => {
	return localStorage.removeItem("OriginRouters")
}


export const setSysConfigStorage = (val) => {
	if (Array.isArray(val)) {
		for (let item of val) {
			localStorage.setItem('SysConfig' + item.code, JSON.stringify(item))
		}
	} else {
		localStorage.setItem('SysConfig' + val.code, JSON.stringify(val))
	}
}

export const getSysConfigStorage = (code, defaultValue) => {
	let sysConfig = localStorage.getItem('SysConfig' + code);
	if (sysConfig) {
		return JSON.parse(sysConfig).value;
	}
	return defaultValue;
}

export const removeSysConfigStorage = (val) => {
	if (Array.isArray(val)) {
		for (item of val) {
			localStorage.removeItem('SysConfig' + item)
		}
	} else {
		localStorage.removeItem('SysConfig' + val.code)
	}
}


export const setTopOrganization = (val) => {
	localStorage.setItem('TopOrganization', JSON.stringify(val))
}
export const getTopOrganization = () => {
	return localStorage.getItem('TopOrganization') ? JSON.parse(localStorage.getItem("TopOrganization")) : null
}
export const removeTopOrganization = () => {
	return localStorage.removeItem("TopOrganization")
}

export const setCurOrg = (val) => {
	localStorage.setItem('CurOrg', JSON.stringify(val))
}
export const getCurOrg = () => {
	return localStorage.getItem('CurOrg') ? JSON.parse(localStorage.getItem("CurOrg")) : null
}
export const removeCurOrg = () => {
	return localStorage.removeItem("CurOrg")
}


// WEBPACK FOOTER //
// ./src/utils/storageUtil.js